module.exports = __webpack_public_path__ + "static/assets/5c09c852b427c6ada0f0e60e03cfcd1c.png";